// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import * as api from '../api';
// import SEO from './SEO';
// import { Shield, Zap, Users, Calendar, Tag, Mail, KeyRound, X } from 'lucide-react';

// const PricingCalculator = () => {
//   const navigate = useNavigate();

//   const [users, setUsers] = useState(1);
//   const [months, setMonths] = useState(1);
//   const [coupon, setCoupon] = useState('');

//   const [total, setTotal] = useState(500);
//   const [basePriceApplied, setBasePriceApplied] = useState(500);
//   const [loading, setLoading] = useState(false);

//   // --- OTP Verification State ---
//   const [showOtpModal, setShowOtpModal] = useState(false);
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   const [otpSent, setOtpSent] = useState(false);
//   const [resendTimer, setResendTimer] = useState(0);

//   // --- Helper: Load Razorpay Script Manually ---
//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   // 1. Auto-Calculate Price
//   useEffect(() => {
//     const calculate = async () => {
//       if (users < 1 || months < 1) return;

//       try {
//         const res = await api.calculatePrice({ users, months, coupon });
//         setTotal(res.data.total_price);
//         setBasePriceApplied(res.data.base_price_applied);
//       } catch (err) {
//         console.error("Price Calc Error", err);
//       }
//     };

//     const timeout = setTimeout(calculate, 500);
//     return () => clearTimeout(timeout);
//   }, [users, months, coupon]);

//   // Resend Timer Countdown
//   useEffect(() => {
//       let interval = null;
//       if (resendTimer > 0) {
//           interval = setInterval(() => setResendTimer(prev => prev - 1), 1000);
//       }
//       return () => clearInterval(interval);
//   }, [resendTimer]);

//   // 2. Handle Manual Input Safety
//   const handleUserChange = (e) => {
//       const val = parseInt(e.target.value);
//       setUsers(isNaN(val) ? '' : val);
//   };

//   const handleMonthChange = (e) => {
//       const val = parseInt(e.target.value);
//       setMonths(isNaN(val) ? '' : val);
//   };

//   const ensureValidNumbers = () => {
//       if (!users || users < 1) setUsers(1);
//       if (!months || months < 1) setMonths(1);
//   };

//   // 3. Start Payment Process -> Check Auth & Show Modal
//   const initiateCheckout = () => {
//     ensureValidNumbers();

//     // --- AUTHENTICATION CHECK ---
//     const isLoggedIn = localStorage.getItem('token') !== null;

//     if (!isLoggedIn) {
//       navigate('/login', { state: { from: '/pricing' } });
//       return;
//     }

//     // Open the OTP Modal if logged in
//     setShowOtpModal(true);
//   };

//   // 4. Send OTP via API
//   const handleSendOtp = async (e) => {
//       e?.preventDefault();
//       if(!email) return alert("Please enter your email");

//       setLoading(true);
//       try {
//           await api.sendOtp({ email });
//           setOtpSent(true);
//           setResendTimer(60); // Start 60-second cooldown
//       } catch (err) {
//           alert(err.response?.data?.message || "Failed to send OTP. Is the backend running?");
//       }
//       setLoading(false);
//   };

//   // 5. Verify OTP & Launch Razorpay
//   const handleVerifyAndPay = async (e) => {
//     e.preventDefault();
//     if(!otp) return alert("Please enter the OTP");

//     setLoading(true);
//     try {
//       // A. Verify OTP with backend
//       await api.verifyOtp({ email, otp });

//       // B. Close Modal & Load Razorpay
//       setShowOtpModal(false);
//       const isLoaded = await loadRazorpayScript();
//       if (!isLoaded) {
//         alert("Failed to load Razorpay SDK. Check connection.");
//         setLoading(false);
//         return;
//       }

//       // C. Create Order
//       const orderRes = await api.createOrder({ users, months, coupon });
//       const order = orderRes.data;

//       // D. Open Razorpay Window
//       const options = {
//         key: "rzp_live_vouAtl4ZPczAok",
//         amount: order.amount,
//         currency: "INR",
//         name: "QryptShield VPN",
//         description: `${users} User License (${months} Months)`,
//         order_id: order.id,
//         handler: async (response) => {
//           try {
//             // E. Verify Payment
//             const verifyRes = await api.verifyPayment({
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_signature: response.razorpay_signature,
//               email: email, // Use the OTP-verified email
//               users: users,
//               months: months
//             });

//             if (verifyRes.data.status === "success") {
//               alert(`🎉 Success! License Key sent to ${email}\nKey: ${verifyRes.data.license_key}`);
//               navigate('/dashboard'); // Optional: redirect to dashboard after purchase
//             }
//           } catch (err) { alert("Payment Verification Failed."); }
//         },
//         prefill: { email: email },
//         theme: { color: "#0ea5e9" },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.on("payment.failed", function (response) {
//         alert("Payment Failed: " + response.error.description);
//       });
//       rzp.open();

//     } catch (err) {
//         alert(err.response?.data?.message || "Invalid or Expired OTP");
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="max-w-4xl mx-auto py-12 px-4 relative">
//       <SEO title="Pricing" description="Calculate your QryptShield enterprise pricing. Volume discounts automatically applied." />

//       {/* --- OTP MODAL OVERLAY --- */}
//       {showOtpModal && (
//           <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
//               <div className="bg-gray-900 border border-gray-700 p-8 rounded-2xl w-full max-w-md shadow-2xl relative">
//                   <button onClick={() => setShowOtpModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition">
//                       <X />
//                   </button>
//                   <h3 className="text-2xl font-bold text-white mb-2 text-center">Verify Email</h3>
//                   <p className="text-gray-400 text-sm text-center mb-6">Where should we send your license key?</p>

//                   {!otpSent ? (
//                       <form onSubmit={handleSendOtp} className="space-y-4">
//                           <div>
//                               <label className="text-sm text-gray-400 flex items-center gap-2 mb-2"><Mail className="w-4 h-4"/> Email Address</label>
//                               <input
//                                   type="email"
//                                   required
//                                   className="w-full bg-gray-800 p-3 rounded outline-none text-white border border-gray-700 focus:border-qrypt-primary transition"
//                                   value={email}
//                                   onChange={(e)=>setEmail(e.target.value)}
//                               />
//                           </div>
//                           <button type="submit" disabled={loading} className="w-full bg-qrypt-primary hover:bg-blue-600 text-white font-bold py-3 rounded transition">
//                               {loading ? "Sending..." : "Send OTP"}
//                           </button>
//                       </form>
//                   ) : (
//                       <form onSubmit={handleVerifyAndPay} className="space-y-4">
//                           <div>
//                               <label className="text-sm text-gray-400 flex items-center gap-2 mb-2"><KeyRound className="w-4 h-4"/> Enter 6-Digit OTP</label>
//                               <input
//                                   type="text"
//                                   maxLength="6"
//                                   required
//                                   className="w-full bg-gray-800 p-3 rounded outline-none text-white border border-gray-700 focus:border-qrypt-primary text-center tracking-[0.5em] font-bold text-xl transition"
//                                   value={otp}
//                                   onChange={(e)=>setOtp(e.target.value)}
//                               />
//                           </div>

//                           <button type="submit" disabled={loading} className="w-full bg-green-600 hover:bg-green-500 text-white font-bold py-3 rounded transition">
//                               {loading ? "Verifying..." : "Verify & Pay"}
//                           </button>

//                           <div className="text-center mt-4">
//                               <button
//                                   type="button"
//                                   disabled={resendTimer > 0 || loading}
//                                   onClick={handleSendOtp}
//                                   className="text-sm text-blue-400 hover:text-blue-300 disabled:text-gray-600 transition"
//                               >
//                                   {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : "Didn't receive code? Resend"}
//                               </button>
//                           </div>
//                       </form>
//                   )}
//               </div>
//           </div>
//       )}

//       {/* --- PAGE CONTENT --- */}
//       <div className="text-center mb-12">
//         <h2 className="text-4xl font-bold text-white mb-4">Build Your Quantum Shield</h2>
//         <p className="text-gray-400 text-lg">Enter your requirements below. Dynamic volume pricing applies.</p>
//       </div>

//       <div className="grid md:grid-cols-2 gap-8">

//         {/* LEFT: Controls (Manual Inputs) */}
//         <div className="bg-qrypt-card p-8 rounded-2xl border border-gray-700 shadow-2xl">

//           <div className="mb-8">
//             <label className="flex items-center gap-2 text-lg font-medium text-gray-300 mb-2">
//               <Users className="w-5 h-5 text-qrypt-primary"/> Number of Users
//             </label>
//             <input
//               type="number"
//               min="1"
//               value={users}
//               onChange={handleUserChange}
//               onBlur={ensureValidNumbers}
//               className="w-full bg-gray-900 border border-gray-600 rounded-lg p-3 text-white text-xl font-bold focus:border-qrypt-primary outline-none transition"
//             />
//             {basePriceApplied < 500 && (
//                 <p className="text-sm text-green-400 mt-2 font-bold">🎉 Volume discount active: ₹{basePriceApplied} / user</p>
//             )}
//           </div>

//           <div className="mb-8">
//             <label className="flex items-center gap-2 text-lg font-medium text-gray-300 mb-2">
//               <Calendar className="w-5 h-5 text-qrypt-primary"/> Duration (Months)
//             </label>
//             <input
//               type="number"
//               min="1"
//               value={months}
//               onChange={handleMonthChange}
//               onBlur={ensureValidNumbers}
//               className="w-full bg-gray-900 border border-gray-600 rounded-lg p-3 text-white text-xl font-bold focus:border-qrypt-primary outline-none transition"
//             />
//           </div>

//           <div className="mb-4">
//              <label className="flex items-center gap-2 text-gray-300 mb-2">
//                  <Tag className="w-4 h-4 text-green-400"/> Coupon Code
//              </label>
//              <input
//                  type="text"
//                  placeholder="e.g. STUDENT50"
//                  className="w-full bg-gray-900 border border-gray-600 rounded p-3 text-white uppercase focus:border-qrypt-primary outline-none transition"
//                  value={coupon}
//                  onChange={(e) => setCoupon(e.target.value)}
//              />
//           </div>

//           <div className="space-y-3 pt-6 border-t border-gray-700 mt-8">
//             <div className="flex items-center gap-3 text-gray-300"><Shield className="w-5 h-5 text-green-400" /> Post-Quantum Kyber-1024</div>
//             <div className="flex items-center gap-3 text-gray-300"><Zap className="w-5 h-5 text-yellow-400" /> WireGuard High-Speed Core</div>
//           </div>
//         </div>

//         {/* RIGHT: Summary */}
//         <div className="bg-gradient-to-br from-gray-900 to-qrypt-dark p-8 rounded-2xl border border-gray-700 flex flex-col justify-between">
//           <div>
//             <h3 className="text-2xl font-bold text-white mb-6">Plan Summary</h3>
//             <div className="flex justify-between mb-2 text-gray-400"><span>Users</span><span className="font-bold text-white">{users || 0}</span></div>
//             <div className="flex justify-between mb-4 text-gray-400"><span>Duration</span><span className="font-bold text-white">{months || 0} Months</span></div>

//             <div className="h-px bg-gray-700 my-4"></div>

//             <div className="flex justify-between items-end mb-2">
//               <span className="text-lg text-gray-300">Total Price</span>
//               <span className="text-4xl font-bold text-qrypt-primary">₹{total.toLocaleString()}</span>
//             </div>
//             {coupon && total === 0 && <span className="text-green-400 text-sm block text-right font-bold">Coupon Applied! (100% Free)</span>}
//           </div>

//           <button
//             onClick={initiateCheckout}
//             disabled={loading || users < 1 || months < 1}
//             className={`w-full py-4 mt-8 rounded-xl font-bold text-lg shadow-lg transition-all transform hover:scale-105
//               ${loading || users < 1 || months < 1 ? 'bg-gray-600 cursor-not-allowed' : 'bg-qrypt-primary hover:bg-blue-600 text-white'}`}
//           >
//             {loading ? "Processing..." : "Pay Now 🚀"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PricingCalculator;

// change code 25/02/2026

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../api";
import SEO from "./SEO";
import {
  Shield,
  Zap,
  Users,
  Calendar,
  Tag,
  Mail,
  X,
  CheckCircle2,
  Loader2,
  ArrowRight,
  CreditCard,
} from "lucide-react";

const PricingCalculator = () => {
  const navigate = useNavigate();

  const [users, setUsers] = useState(1);
  const [months, setMonths] = useState(1);
  const [coupon, setCoupon] = useState("");

  const [total, setTotal] = useState(500);
  const [basePriceApplied, setBasePriceApplied] = useState(500);
  const [loading, setLoading] = useState(false);

  // --- OTP Verification State ---
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  // --- Helper: Load Razorpay Script Manually ---
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // 1. Auto-Calculate Price
  useEffect(() => {
    const calculate = async () => {
      if (users < 1 || months < 1) return;

      try {
        const res = await api.calculatePrice({ users, months, coupon });
        setTotal(res.data.total_price);
        setBasePriceApplied(res.data.base_price_applied);
      } catch (err) {
        console.error("Price Calc Error", err);
      }
    };

    const timeout = setTimeout(calculate, 500);
    return () => clearTimeout(timeout);
  }, [users, months, coupon]);

  // Resend Timer Countdown
  useEffect(() => {
    let interval = null;
    if (resendTimer > 0) {
      interval = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  // 2. Handle Manual Input Safety
  const handleUserChange = (e) => {
    const val = parseInt(e.target.value);
    setUsers(isNaN(val) ? "" : val);
  };

  const handleMonthChange = (e) => {
    const val = parseInt(e.target.value);
    setMonths(isNaN(val) ? "" : val);
  };

  const ensureValidNumbers = () => {
    if (!users || users < 1) setUsers(1);
    if (!months || months < 1) setMonths(1);
  };

  // 3. Start Payment Process -> Check Auth & Show Modal
  const initiateCheckout = () => {
    ensureValidNumbers();

    // --- AUTHENTICATION CHECK ---
    const isLoggedIn = localStorage.getItem("token") !== null;

    if (!isLoggedIn) {
      navigate("/login", { state: { from: "/pricing" } });
      return;
    }

    // Open the OTP Modal if logged in
    setShowOtpModal(true);
  };

  // 4. Send OTP via API
  const handleSendOtp = async (e) => {
    e?.preventDefault();
    if (!email) return alert("Please enter your email");

    setLoading(true);
    try {
      await api.sendOtp({ email });
      setOtpSent(true);
      setResendTimer(60); // Start 60-second cooldown
    } catch (err) {
      alert(
        err.response?.data?.message ||
          "Failed to send OTP. Is the backend running?",
      );
    }
    setLoading(false);
  };

  // 5. Verify OTP & Launch Razorpay
  const handleVerifyAndPay = async (e) => {
    e.preventDefault();
    if (!otp) return alert("Please enter the OTP");

    setLoading(true);
    try {
      // A. Verify OTP with backend
      await api.verifyOtp({ email, otp });

      // B. Close Modal & Load Razorpay
      setShowOtpModal(false);
      const isLoaded = await loadRazorpayScript();
      if (!isLoaded) {
        alert("Failed to load Razorpay SDK. Check connection.");
        setLoading(false);
        return;
      }

      // C. Create Order
      const orderRes = await api.createOrder({ users, months, coupon });
      const order = orderRes.data;

      // D. Open Razorpay Window
      const options = {
        key: "rzp_live_vouAtl4ZPczAok",
        amount: order.amount,
        currency: "INR",
        name: "QryptShield VPN",
        description: `${users} User License (${months} Months)`,
        order_id: order.id,
        handler: async (response) => {
          try {
            // E. Verify Payment
            const verifyRes = await api.verifyPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              email: email, // Use the OTP-verified email
              users: users,
              months: months,
            });

            if (verifyRes.data.status === "success") {
              alert(
                `🎉 Success! License Key sent to ${email}\nKey: ${verifyRes.data.license_key}`,
              );
              navigate("/dashboard"); // Optional: redirect to dashboard after purchase
            }
          } catch (err) {
            alert("Payment Verification Failed.");
          }
        },
        prefill: { email: email },
        theme: { color: "#0ea5e9" },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (response) {
        alert("Payment Failed: " + response.error.description);
      });
      rzp.open();
    } catch (err) {
      alert(err.response?.data?.message || "Invalid or Expired OTP");
    }
    setLoading(false);
  };

  return (
    <div className="relative min-h-screen py-20 px-4 overflow-hidden bg-[#0B0F19]">
      <SEO
        title="Pricing"
        description="Calculate your QryptShield enterprise pricing."
      />

      {/* --- Background Effects --- */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage: `linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[100px]" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-[100px]" />
      </div>

      {/* --- OTP MODAL OVERLAY --- */}
      {showOtpModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setShowOtpModal(false)}
          />

          {/* Modal Content */}
          <div className="relative bg-[#0F1623] border border-white/10 p-8 rounded-2xl w-full max-w-md shadow-2xl animate-in zoom-in-95 duration-200">
            <button
              onClick={() => setShowOtpModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-white transition bg-white/5 p-1 rounded-full"
            >
              <X size={18} />
            </button>

            <div className="text-center mb-6">
              <div className="w-12 h-12 bg-blue-500/10 rounded-full flex items-center justify-center mx-auto mb-4 border border-blue-500/20">
                <Shield className="w-6 h-6 text-blue-400" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">
                Security Check
              </h3>
              <p className="text-gray-400 text-sm">
                To ensure secure delivery of your license key, please verify
                your email.
              </p>
            </div>

            {!otpSent ? (
              <form onSubmit={handleSendOtp} className="space-y-4">
                <div className="space-y-2">
                  <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider ml-1">
                    Email Address
                  </label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-3.5 w-5 h-5 text-gray-500" />
                    <input
                      type="email"
                      required
                      className="w-full bg-[#1A202C] pl-10 pr-4 py-3 rounded-xl outline-none text-white border border-gray-700 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all placeholder-gray-600"
                      placeholder="name@company.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3.5 rounded-xl transition shadow-lg shadow-blue-500/20 flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <Loader2 className="animate-spin w-5 h-5" />
                  ) : (
                    <>
                      Send OTP <ArrowRight className="w-4 h-4" />
                    </>
                  )}
                </button>
              </form>
            ) : (
              <form onSubmit={handleVerifyAndPay} className="space-y-6">
                <div className="space-y-2 text-center">
                  <label className="text-sm font-medium text-gray-300">
                    Enter Verification Code
                  </label>
                  <input
                    type="text"
                    maxLength="6"
                    required
                    className="w-full bg-[#1A202C] py-4 rounded-xl outline-none text-white border border-gray-700 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-center tracking-[0.75em] font-bold text-2xl transition-all"
                    placeholder="000000"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  <p className="text-xs text-gray-500">Sent to {email}</p>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3.5 rounded-xl transition shadow-lg shadow-emerald-500/20 flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <Loader2 className="animate-spin w-5 h-5" />
                  ) : (
                    <>
                      Verify & Pay <CreditCard className="w-4 h-4" />
                    </>
                  )}
                </button>

                <div className="text-center">
                  <button
                    type="button"
                    disabled={resendTimer > 0 || loading}
                    onClick={handleSendOtp}
                    className="text-sm text-blue-400 hover:text-blue-300 disabled:text-gray-600 disabled:cursor-not-allowed transition font-medium"
                  >
                    {resendTimer > 0
                      ? `Resend code in ${resendTimer}s`
                      : "Resend Code"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* --- PAGE CONTENT --- */}
      <div className="relative z-10 max-w-5xl mx-auto mt-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-300 text-xs font-medium mb-6">
            <Zap size={14} className="fill-blue-500/20" /> Dynamic Volume
            Pricing
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Build Your{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">
              Quantum Shield
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
            Customize your plan based on your team size. The more users you add,
            the more you save per license.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 items-start">
          {/* LEFT: Controls (Manual Inputs) */}
          <div className="lg:col-span-7 bg-white/[0.03] backdrop-blur-xl border border-white/10 p-8 rounded-3xl shadow-2xl">
            <div className="space-y-8">
              {/* Users Input */}
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <label className="flex items-center gap-2 text-lg font-medium text-white">
                    <Users className="w-5 h-5 text-blue-400" /> Team Size
                  </label>
                  <span className="text-xs font-mono text-gray-500 bg-white/5 px-2 py-1 rounded">
                    MIN: 1
                  </span>
                </div>

                <div className="relative group">
                  <input
                    type="number"
                    min="1"
                    value={users}
                    onChange={handleUserChange}
                    onBlur={ensureValidNumbers}
                    className="w-full bg-[#0B0F19] border border-gray-700 rounded-xl p-4 text-white text-2xl font-bold focus:border-blue-500 outline-none transition-all group-hover:border-gray-600 pl-4"
                  />
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">
                    Users
                  </div>
                </div>

                {basePriceApplied < 500 && (
                  <div className="flex items-center gap-2 text-sm text-emerald-400 bg-emerald-500/10 p-3 rounded-lg border border-emerald-500/20">
                    <CheckCircle2 size={16} />
                    <span>
                      Volume discount active:{" "}
                      <strong>₹{basePriceApplied}/user</strong>
                    </span>
                  </div>
                )}
              </div>

              {/* Duration Input */}
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <label className="flex items-center gap-2 text-lg font-medium text-white">
                    <Calendar className="w-5 h-5 text-purple-400" /> Billing
                    Cycle
                  </label>
                </div>
                <div className="relative group">
                  <input
                    type="number"
                    min="1"
                    value={months}
                    onChange={handleMonthChange}
                    onBlur={ensureValidNumbers}
                    className="w-full bg-[#0B0F19] border border-gray-700 rounded-xl p-4 text-white text-2xl font-bold focus:border-blue-500 outline-none transition-all group-hover:border-gray-600 pl-4"
                  />
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">
                    Months
                  </div>
                </div>
              </div>

              {/* Coupon Input */}
              <div className="pt-6 border-t border-white/10">
                <label className="flex items-center gap-2 text-sm font-medium text-gray-400 mb-3 uppercase tracking-wider">
                  <Tag className="w-4 h-4" /> Promo Code
                </label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    placeholder="ENTER CODE"
                    className="w-full bg-[#0B0F19] border border-gray-700 rounded-lg p-3 text-white uppercase focus:border-blue-500 outline-none transition-all text-sm font-medium tracking-wide placeholder-gray-600"
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Features List */}
            <div className="mt-8 pt-8 border-t border-white/10 grid grid-cols-2 gap-4">
              <div className="flex items-center gap-3 text-gray-300 text-sm">
                <div className="p-1.5 rounded-full bg-emerald-500/20">
                  <Shield className="w-4 h-4 text-emerald-400" />
                </div>
                Post-Quantum Encrypted
              </div>
              <div className="flex items-center gap-3 text-gray-300 text-sm">
                <div className="p-1.5 rounded-full bg-yellow-500/20">
                  <Zap className="w-4 h-4 text-yellow-400" />
                </div>
                High-Speed WireGuard Core
              </div>
            </div>
          </div>

          {/* RIGHT: Summary Card */}
          <div className="lg:col-span-5 relative">
            <div className="sticky top-24">
              <div className="bg-gradient-to-b from-blue-900/40 to-[#0B0F19] p-8 rounded-3xl border border-blue-500/30 shadow-[0_0_50px_-12px_rgba(59,130,246,0.3)] backdrop-blur-xl">
                <h3 className="text-xl font-bold text-white mb-8 flex items-center gap-2">
                  Order Summary
                </h3>

                <div className="space-y-4 mb-8">
                  <div className="flex justify-between items-center text-gray-400">
                    <span>Licenses</span>
                    <span className="font-medium text-white">
                      {users || 0} Users
                    </span>
                  </div>
                  <div className="flex justify-between items-center text-gray-400">
                    <span>Duration</span>
                    <span className="font-medium text-white">
                      {months || 0} Months
                    </span>
                  </div>
                  <div className="flex justify-between items-center text-gray-400">
                    <span>Base Rate</span>
                    <span className="font-medium text-white">
                      ₹{basePriceApplied}/mo
                    </span>
                  </div>
                  {coupon && total === 0 && (
                    <div className="flex justify-between items-center text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded">
                      <span>Discount</span>
                      <span className="font-bold">-100%</span>
                    </div>
                  )}
                </div>

                <div className="h-px bg-white/10 my-6"></div>

                <div className="flex justify-between items-end mb-8">
                  <span className="text-gray-300 font-medium">
                    Total Amount
                  </span>
                  <div className="text-right">
                    <span className="text-4xl font-bold text-white tracking-tight">
                      ₹{total.toLocaleString()}
                    </span>
                    <p className="text-xs text-gray-500 mt-1">GST Included</p>
                  </div>
                </div>

                <button
                  onClick={initiateCheckout}
                  disabled={loading || users < 1 || months < 1}
                  className={`w-full py-4 rounded-xl font-bold text-lg shadow-lg shadow-blue-500/25 transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2
                    ${
                      loading || users < 1 || months < 1
                        ? "bg-gray-800 text-gray-500 cursor-not-allowed border border-white/5"
                        : "bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-500 hover:to-cyan-400 text-white"
                    }`}
                >
                  {loading ? (
                    <Loader2 className="animate-spin" />
                  ) : (
                    <CreditCard size={20} />
                  )}
                  {loading ? "Processing..." : "Proceed to Pay"}
                </button>

                <p className="text-center text-xs text-gray-500 mt-4 flex items-center justify-center gap-1">
                  <Shield size={12} /> Secure Payment via Razorpay
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingCalculator;
